import { Component, Inject, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { FormBuilder, FormGroupName, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AuthService } from '../../_services/auth.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ErrorHandlerService } from '../../_services/error-handler.service';


@Component({
  selector: 'app-login',
  imports: [RouterModule, FormsModule, ReactiveFormsModule, CommonModule],
  providers: [AuthService],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  loginForm:any = FormGroupName;
  isLoading: boolean = false;
  errorMessage: string = '';
  private _snackBar = inject(MatSnackBar);

  constructor(
    private _fb: FormBuilder,
    private _AS: AuthService,
    private router:Router,
    private errorHandler: ErrorHandlerService,
    @Inject(PLATFORM_ID) private platformId: Object
  ){}

  ngOnInit(){
    this.formControls()
  }
  formControls(){
    this.loginForm = this._fb.group({
      phone:['',[Validators.required, Validators.minLength(3)]],
      password:['',[Validators.required, Validators.minLength(3)]]
    })
  }

  loginUser(){
    if (this.loginForm.invalid) {
      this.errorMessage = 'Please fill in all required fields correctly.';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this._AS.userLogin(this.loginForm.value).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res.message === 'SSR mode') {
          return;
        }
        
        if (res.status && (res.data?.role == 'ADMIN' || ['super_admin','admin','property_manager','sales_advisor','user'].includes(res.data.role.id))) {
          this._snackBar.open(res.message || 'Login successful!', 'close', {
            duration: 3000,
            panelClass: ['success-snackbar']
          });
          if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('Admin_User', JSON.stringify(res));
            this._AS.setUser(res)
            if(res.data?.role == 'ADMIN' || ['super_admin','admin'].includes(res.data.role.id)){
              this.router.navigate(['/admin/dashboard'])
            } else if(['property_manager','sales_advisor'].includes(res.data.role.id)){
              this.router.navigate(['/admin/property'])
            } else{
              this.router.navigate(['/unauthorized'])
            }
          }
          ;
        } else {
          this.errorMessage = res.message || 'You need admin role to access this application.';
          this._snackBar.open(this.errorMessage, 'close', {
            duration: 3000,
            panelClass: ['error-snackbar']
          });
        }
      },
      error: (error) => {
        this.isLoading = false;
        
        // Handle structured error response
        if (error.status === false) {
          this.errorMessage = error.message;
        } else {
          this.errorMessage = 'Login failed. Please check your credentials and try again.';
        }
        
        this._snackBar.open(this.errorMessage, 'close', {
          duration: 3000,
          panelClass: ['error-snackbar']
        });
        
        // Use error handler for additional logging
        this.errorHandler.handleError(error, 'Login');
      }
    });
  }
}
